// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.footer-contact[data-v-3af268b0] {

    border-top-width: 2px;

    --tw-border-opacity: 1;

    border-color: rgb(229 231 235 / var(--tw-border-opacity));

    --tw-bg-opacity: 1;

    background-color: rgb(255 255 255 / var(--tw-bg-opacity));

    padding-top: 2rem;

    padding-bottom: 2.5rem;

    --tw-text-opacity: 1;

    color: rgb(17 24 39 / var(--tw-text-opacity))
}
@media (min-width: 640px) {
.footer-contact[data-v-3af268b0] {

        padding-top: 3.5rem;

        padding-bottom: 3.5rem
}
}
.footer-contact__jumbo[data-v-3af268b0] {

    display: flex;

    flex-direction: column;

    row-gap: 2rem;

    -moz-column-gap: 4rem;

         column-gap: 4rem;

    width: 100%;

    padding-right: 1rem;

    padding-left: 1rem;

    margin: auto
}
@media (min-width: 640px) {
.footer-contact__jumbo[data-v-3af268b0] {

        padding-right: 1.5rem;

        padding-left: 1.5rem
}
}
@media (min-width: 1320px) {
.footer-contact__jumbo[data-v-3af268b0] {

        max-width: 1320px;

        width: calc((1320px - 1.5rem) / 12 * 10 + 1.5rem)
}
}
@media (min-width: 640px) {
.footer-contact__jumbo[data-v-3af268b0] {

        flex-direction: row
}
}
@media (min-width: 1320px) {
.footer-contact__jumbo[data-v-3af268b0] {

        -moz-column-gap: 7.5rem;

             column-gap: 7.5rem
}
}
.footer-contact__title[data-v-3af268b0] {

    margin-bottom: 0.5rem;

    font-family: Mont;

    line-height: 1.35;

    font-size: 1.5rem;

    font-weight: 700
}
.footer-contact__claim[data-v-3af268b0] {

    font-family: Roboto;

    line-height: 1.35;

    font-size: 1.125rem;

    font-weight: 400
}
.footer-contact__info[data-v-3af268b0] {

    display: flex;

    flex-direction: column;

    gap: 0.75rem
}
.footer-contact__item[data-v-3af268b0] {

    display: flex;

    gap: 0.75rem
}
.footer-contact__links[data-v-3af268b0] {

    display: flex;

    width: 100%;

    flex-direction: column
}
.footer-contact__links a[data-v-3af268b0]:hover {

    text-decoration-line: underline
}
.footer-contact[data-v-3af268b0] .jumbo__content {

    align-items: flex-start;

    -moz-column-gap: 4rem;

         column-gap: 4rem;

    row-gap: 2rem;

    padding: 0
}
@media (min-width: 640px) {
.footer-contact[data-v-3af268b0] .jumbo__content {

        flex-direction: row
}
}
.footer-contact[data-v-3af268b0] .jumbo__content--before {

    width: 100%;

    text-align: center
}
@media (min-width: 640px) {
.footer-contact[data-v-3af268b0] .jumbo__content--before {

        width: -moz-fit-content;

        width: fit-content;

        text-align: left
}
}
.footer-contact[data-v-3af268b0] .jumbo__content--after {

    margin-left: auto;

    margin-right: auto;

    display: flex;

    flex-direction: column;

    gap: 2.5rem
}
@media (min-width: 640px) {
.footer-contact[data-v-3af268b0] .jumbo__content--after {

        margin: 0
}
}
@media (min-width: 996px) {
.footer-contact[data-v-3af268b0] .jumbo__content--after {

        flex-direction: row;

        gap: 5rem
}
}
.footer-contact[data-v-3af268b0] .jumbo__content--after .we-call-you__btn {

    margin: 0
}
`, "",{"version":3,"sources":["webpack://./resources/js/lego/partials/FooterContact.vue"],"names":[],"mappings":";AAwDA;;IAAA,qBAAA;;IAAA,sBAAA;;IAAA,yDAAA;;IAAA,kBAAA;;IAAA,yDAAA;;IAAA,iBAAA;;IAAA,sBAAA;;IAAA,oBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,mBAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA,aAAA;;IAAA,sBAAA;;IAAA,aAAA;;IAAA,qBAAA;;SAAA,gBAAA;;IAAA,WAAA;;IAAA,mBAAA;;IAAA,kBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,qBAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,iBAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,uBAAA;;aAAA;AAAA;AAAA;AAIA;;IAAA,qBAAA;;IAAA,iBAAA;;IAAA,iBAAA;;IAAA,iBAAA;;IAAA;AAAA;AAIA;;IAAA,mBAAA;;IAAA,iBAAA;;IAAA,mBAAA;;IAAA;AAAA;AAIA;;IAAA,aAAA;;IAAA,sBAAA;;IAAA;AAAA;AAIA;;IAAA,aAAA;;IAAA;AAAA;AAIA;;IAAA,aAAA;;IAAA,WAAA;;IAAA;AAAA;AAGA;;IAAA;AAAA;AAKA;;IAAA,uBAAA;;IAAA,qBAAA;;SAAA,gBAAA;;IAAA,aAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA,WAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA,uBAAA;;QAAA,kBAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA,iBAAA;;IAAA,kBAAA;;IAAA,aAAA;;IAAA,sBAAA;;IAAA;AAAA;AAAA;AAAA;;QAAA;AAAA;AAAA;AAAA;AAAA;;QAAA,mBAAA;;QAAA;AAAA;AAAA;AAGA;;IAAA;AAAA","sourcesContent":["<template>\n  <div class=\"footer-contact\">\n    <Jumbo class=\"footer-contact__jumbo\" size=\"fit\">\n      <template #before>\n        <div class=\"contact-jumbo__claim\">\n          <h2 class=\"footer-contact__title\">¿Quieres más información?</h2>\n          <p class=\"footer-contact__claim\">Habla con un experto hipotecario.</p>\n        </div>\n      </template>\n      <template #after>\n        <div class=\"footer-contact__info\">\n          <div v-for=\"link in links\" :key=\"link.content[0]\" class=\"footer-contact__item\">\n            <Icon class=\"footer-contact__icon\" :name=\"link.icon\" color=\"none\" />\n            <div class=\"footer-contact__links\">\n              <a v-for=\"item in link.content\" :key=\"item\" :href=\"link.href + item\">{{ item }}</a>\n            </div>\n          </div>\n        </div>\n        <WeCallYou />\n      </template>\n    </Jumbo>\n  </div>\n</template>\n\n<script>\nimport Jumbo from '@/lego/components/layout/Jumbo.vue';\nimport Icon from '@/lego/components/icons/Icon.vue';\nimport WeCallYou from '@/lego/partials/home/WeCallYou.vue';\n\nexport default {\n  components: {\n    Jumbo,\n    Icon,\n    WeCallYou,\n  },\n  setup() {\n    return {\n      links: [\n        {\n          content: ['hola@trioteca.com'],\n          icon: 'email',\n          href: 'mailto:',\n        },\n        {\n          content: ['910 054 391'],\n          icon: 'phone',\n          href: 'tel:',\n        },\n      ],\n    };\n  },\n};\n</script>\n\n<style lang=\"postcss\" scoped>\n.footer-contact {\n  @apply pt-xs pb-sm sm:py-lg text-neutral-ultradark bg-neutral-white border-neutral-light border-t-thin;\n\n  &__jumbo {\n    @apply container flex flex-col container-medium gap-y-xs gap-x-xl xl:gap-x-xxxl sm:flex-row;\n  }\n\n  &__title {\n    @apply style-subtitle-bold mb-nano;\n  }\n\n  &__claim {\n    @apply style-body;\n  }\n\n  &__info {\n    @apply flex flex-col gap-micro;\n  }\n\n  &__item {\n    @apply flex gap-micro;\n  }\n\n  &__links {\n    @apply flex flex-col w-full;\n\n    a {\n      @apply hover:underline;\n    }\n  }\n\n  /deep/ .jumbo__content {\n    @apply items-start p-0 sm:flex-row gap-x-xl gap-y-xs;\n\n    &--before {\n      @apply sm:w-fit w-full sm:text-left text-center;\n    }\n    &--after {\n      @apply flex flex-col lg:flex-row gap-sm lg:gap-xxl mx-auto sm:m-0;\n\n      .we-call-you__btn {\n        @apply m-0;\n      }\n    }\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
